import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out the pre-React loading screen once App has mounted.
requestAnimationFrame(() => {
  const loader = document.getElementById('initial-loader');
  if (!loader) return;
  loader.style.transition = 'opacity 300ms ease';
  loader.style.opacity = '0';
  setTimeout(() => loader.remove(), 320);
});
